function setUpGoogleScript(id) {
  const script = document.createElement("script");
  const nonce = document.querySelector('[nonce]');
  script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`
  script.async = true;
  nonce && script.setAttribute('nonce', nonce.nonce || nonce.getAttribute('nonce'));
  document.head.appendChild(script);
}

function setUpDataLayer() {
  window.dataLayer = window.dataLayer || [];
}

function gtag() {
  window.dataLayer.push(arguments);
}

const id = document.getElementById('analytics').dataset.googleAnalyticsId;

if (id) {
  setUpGoogleScript(id);
  setUpDataLayer();
  gtag('js', new Date());
  gtag('config', id);
}
